import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cp-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkComponent {
  @Input()
  isButton = false;

  @Input()
  linkClass?: string;

  @Input()
  label?: string;

  @Input()
  icon?: string;

  @Input()
  colorClass = 'branding-accent-normal-fill';

  @Input()
  route?: string[];

  @Input()
  link?: string;

  get title() {
    return this.icon && this.label ? this.label : null;
  }
}
